import React from 'react';
import classes from './PulsingAvatar.module.scss';
import AvatarIcon, { IconType } from './AvatarIcon';

interface PulsingAvatarProps {
  icon: IconType;
}

const PulsingAvatar = (props: PulsingAvatarProps) => {
  const { icon } = props;

  return (
    <div className={classes.avatarContainer}>
      <div className={classes.pulseContainer}>
        <div className={`${classes.pulse} ${classes.pulseOuter}`} />
      </div>
      <div className={classes.pulseContainer}>
        <div className={`${classes.pulse} ${classes.pulseInner}`} />
      </div>
      <div className={classes.avatar}>
        <AvatarIcon iconType={icon} />
      </div>
    </div>
  );
};

export default PulsingAvatar;
